module.exports = __webpack_public_path__ + "static/patrick-3bd284d0bc84f223bda44fb3a55e2f41.png";